import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../user/user.service';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApportisHubService } from '../apportis.hub.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  private spinnerCount = 0;

  excludeHosts: any[] = [
    'maps.googleapis.com'
  ];

  constructor(private userService: UserService, private spinnerService: NgxSpinnerService
    , private router: Router, private apportisHubservice: ApportisHubService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinnerCount += 1;
    if (!this.userService.isSpinnerHide.value) {
      this.spinnerService.show();
    }
    const token = localStorage.getItem('AuthToken');

    if (token && token != null && !this.excludeHosts.includes(this.parseHostname(request.url))) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.spinnerCount -= 1;
            if (this.spinnerCount == 0) {
              this.spinnerService.hide();
            }
          }
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.spinnerCount -= 1;
            if (this.spinnerCount == 0) {
              this.spinnerService.hide();
            }
          }
          if (err.status == 401) {
            this.signOut();
            // session expired
            window.location.replace('/signin');
            // window.location.replace('/unauthorized');

          }
          if (err.status == 500) {
            this.signOut();
            window.location.replace('/internal-error');
          }



        }),
      );
  }

  // returns the hostname of the url passed.
  parseHostname(url: string) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      return match[2];
    } else {
      return null;
    }
  }

  public signOut() {
    this.userService.deleteActiveLogin(this.userService.CurrentUser.userId);
    if (this.apportisHubservice != undefined && this.apportisHubservice.connection != undefined) {
      this.apportisHubservice.closeConenction();
    }
    this.userService.CurrentUser = null;
    localStorage.clear();
  }
}
